{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "WaterClassesFile",
  "description": "The palette class each water body of the layout takes from Cornelis Anthonisz.'s 1538 painting, keyed by layout id: 'ij', every water area id and every channel id. Written by tools/fields from docs/reference/cornelis-anthonisz-1538.jpg seen through the painter camera and its residual warp (src/data/painterView.json).",
  "type": "object",
  "additionalProperties": false,
  "required": ["version", "source", "method", "bodies"],
  "properties": {
    "version": { "description": "Schema version.", "const": 1 },
    "source": {
      "title": "WaterClassesSource",
      "type": "object",
      "additionalProperties": false,
      "required": ["image", "width", "height"],
      "properties": {
        "image": { "type": "string", "description": "Project-relative path of the painting." },
        "width": { "type": "integer", "description": "Pixels." },
        "height": { "type": "integer", "description": "Pixels." }
      }
    },
    "method": {
      "title": "WaterClassesMethod",
      "type": "object",
      "additionalProperties": false,
      "required": ["stepPx", "minPixels", "vesselMaxLightness", "candidates"],
      "properties": {
        "stepPx": {
          "type": "integer",
          "minimum": 1,
          "description": "Every stepPx-th pixel of the unblurred painting in each direction is sampled."
        },
        "minPixels": {
          "type": "integer",
          "minimum": 1,
          "description": "Fewest voting pixels for a body to vote; a body with fewer takes the class of the linked body of the channel system, sharing a channel end or joint with it, that voted with the most pixels, and keeps the class of its kind where none did. The IJ lends to no body."
        },
        "vesselMaxLightness": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "description": "Pixels darker than this CIE L*, and pixels nearest shipHull, are the strokes of vessels on the water and do not vote."
        },
        "candidates": {
          "type": "array",
          "items": { "$ref": "#/$defs/WaterClass" },
          "minItems": 1,
          "description": "Palette classes the pixels vote among, each fogged to the pixel's painter-view distance."
        }
      }
    },
    "bodies": {
      "type": "object",
      "description": "Keyed by 'ij', layout water area id and layout channel id.",
      "additionalProperties": { "$ref": "#/$defs/WaterBody" }
    }
  },
  "$defs": {
    "WaterClass": {
      "title": "WaterClass",
      "description": "Palette class the water mesh colours the body with.",
      "enum": ["ijWater", "riverWater", "canalWater"]
    },
    "WaterBodyKind": {
      "title": "WaterBodyKind",
      "description": "The kind of water the site gives the body: the IJ, a water area, or its channel's kind.",
      "enum": ["ij", "area", "river", "harbour", "canal", "moat", "ditch"]
    },
    "WaterVotes": {
      "title": "WaterVotes",
      "type": "object",
      "additionalProperties": false,
      "required": ["ijWater", "riverWater", "canalWater"],
      "properties": {
        "ijWater": { "type": "integer", "minimum": 0 },
        "riverWater": { "type": "integer", "minimum": 0 },
        "canalWater": { "type": "integer", "minimum": 0 }
      }
    },
    "WaterBody": {
      "title": "WaterBody",
      "type": "object",
      "additionalProperties": false,
      "required": ["kind", "class", "pixels", "vesselPixels", "votes"],
      "properties": {
        "kind": { "$ref": "#/$defs/WaterBodyKind" },
        "class": { "$ref": "#/$defs/WaterClass" },
        "pixels": {
          "type": "integer",
          "minimum": 0,
          "description": "Sampled painting pixels over the body that voted."
        },
        "vesselPixels": {
          "type": "integer",
          "minimum": 0,
          "description": "Sampled painting pixels over the body left out as vessel strokes."
        },
        "votes": { "$ref": "#/$defs/WaterVotes" },
        "borrowedFrom": {
          "type": "string",
          "minLength": 1,
          "description": "The linked body of the channel system, sharing a channel end or joint with this one and never the IJ, that voted with the most pixels; present where this body had fewer than minPixels voting pixels and takes that body's class."
        },
        "fallback": {
          "const": "kind",
          "description": "Present where the body had fewer than minPixels voting pixels and no body of the channel system linked to it voted, so it keeps the class of its kind."
        }
      }
    }
  }
}
